import { setZoomableImages, smoothAnchorScroll, syncThemeColor } from "@pitayan/gatsby-theme-pitayan/src/utils"

export function onRouteUpdate() {
  // Set gatsby responsive images to zoomable images
  setZoomableImages()

  smoothAnchorScroll()

  // Keep the browser bar matched to the theme in use
  syncThemeColor()
}
